import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { getLabelForKind } from '../utils';
const wrapperCss = "w37jj2b";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const labelCss = "l10ump2z";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const iconColumnCss = "inp6xgk";
const IconColumn = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconColumnCss, props.className)} />;
});
const newIconWrapperCss = "n1y0ndp4";
const NewIconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(newIconWrapperCss, props.className)} />;
});
export const OptionBody = ({
  value
}) => <Wrapper>
    <IconColumn>
      <NewIconWrapper kind={value}>
        <LocationIcon kind={value} />
      </NewIconWrapper>
    </IconColumn>
    <Label>
      {getLabelForKind(value)}
    </Label>
  </Wrapper>;

require("./option_body.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./option_body.js");